import React from "react";
import atmos_logo from "../image/atmos-logo.jpg";
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <div className="navbar-head">
      <nav className="navbar navbar-expand ">
        <Link to={"/atmos/maps"} className="navbar-brand">
          <img src={atmos_logo} alt="atmoslogo" height="62px" />
        </Link>
      </nav>
    </div>
  );
}

export default Navbar;
